function animateBenefits() {
  var element = 0;
  var isAnimating = false;
  var benefitBarKey = "#mobile-benefit-bar-"

  function animateSection() {
    if (!isAnimating) {
      isAnimating = true;

      // Fade out the current section
      $(benefitBarKey + element).animate(
        { opacity: "0" },
        {
          duration: 500,
          done: function () {
            // Hide the current section after the animation
            $(this).css({ display: "none" });

            // Increment and wrap around the element index
            element = (element + 1) % 4;

            // Show and fade in the next section
            $(benefitBarKey + element)
              .css({ display: "block", opacity: "0" })
              .animate(
                { opacity: "1" },
                {
                  duration: 500,
                  done: function () {
                    isAnimating = false;
                  },
                }
              );
          },
        }
      );
    }
  }

  // Set up the interval for animation
  var intervalId = setInterval(animateSection, 3000);
}

animateBenefits();
